import React from "react";
import useFetchObtenerCarnet from "../../../hooks/afiliado/useFetchObtenerCarnet";
import { Modal, Image } from "antd";

const ModalCard = ({ openModalCarnet, handleCloseModalCarnet }) => {
  const { imageData } = useFetchObtenerCarnet();

  return (
    <Modal
      open={openModalCarnet}
      onCancel={handleCloseModalCarnet}
      footer={null}
      centered
      width="auto"
      styles={{ body: { padding: 0, display: "flex", justifyContent: "center" } }}
      aria-label="Carnet digital"
    >
      <Image
        src={`data:image/png;base64,${imageData}`}
        alt="Carnet digital del afiliado"
        style={{
          width: "100%",
          height: "auto",
          maxWidth: 600, // ✅ límite para pantallas grandes
        }}
      />
    </Modal>
  );
};

export default ModalCard;
